import { gql } from '@apollo/client';

export enum EnumWebsiteType {
  BLOG = 'Blog',
  ENTERTAINMENT = 'Entertainment',
  FASHION = 'Fashion',
  FOOD_AND_LIFESTYLE = 'Food_and_Lifestyle',
  HOME_AND_GARDEN = 'Home_and_Garden',
  NEWS = 'News',
  SCIENCE = 'Science',
  SPORT = 'Sport',
  TABLOID = 'Tabloid'
}

export interface Website {
  _id: string,
  name: string,
  url: string,
  type: EnumWebsiteType,
  costPerRead: number,
  minimumSpend: number,
  monthlyVisitors: number,
  publisher: { name: string},
  contimoToken: string,
  __typename: 'Website'
}

const website = `
  _id
  name
  url
  type
  rateCard {
    click
    lead
    read
  }
  minimumSpend
  monthlyVisitors
  advertorialInternalUrl
  contimoToken
  publisher {
    name
    marketplace
  }
  publisherId
  enabledOnMarketplace
  allowSelfHostedAdvertorials
  cpcFloorPrice
  cprFloorPrice
  floorPriceExemptCompanyIds
`

const websiteBrief = `
  _id
  name
  url
  type
  minimumSpend
  monthlyVisitors
  publisher {
    name
    marketplace
  }
  publisherId
  allowSelfHostedAdvertorials
  cpcFloorPrice
  cprFloorPrice
  floorPriceExemptCompanyIds
`

const longWebsite = `
  ${website}
  advertorialSite {
    templateName
    footerCode
    headerCode
    hostingType
    path
    logoImageId
    primaryColor
    secondaryColor
    properties
  }
  ctaButtonSelector
  enabledOnMarketplace
  rateCard {
    read
    click
    lead
  }
  allowSelfHostedAdvertorials
`

export const CREATE_WEBSITE = gql`
  mutation WebsiteCreateOne($input: CreateWebsiteInput!) {
    WebsiteCreateOne(input: $input) {
      ${website}
    }
  }
`

export const GET_WEBSITE =  gql`
  query WebsiteById($websiteId: ObjectId!) {
    website: WebsiteById(_id: $websiteId) {
      ${longWebsite}
    }
  }
`;

export const GET_ALL_WEBSITES = gql`
  query GetAllWebsites($page: Int, $perPage: Int, $filters: WebsiteFilterArgs) {
    websites: WebsiteMany(page: $page, perPage: $perPage, filters: $filters) {
      items{
        ${website}
      }
      meta {
        totalItems
      }
    }
  }
`;

export const GET_ALL_MARKETPLACE_WEBSITES = gql`
  query GetAllMarketPlaceWebsites($page: Int, $perPage: Int, $filters: MarketplaceWebsiteFilterArgs!) {
    websites: MarketplaceWebsiteMany(page: $page, perPage: $perPage, filters: $filters) {
      items {
        ${websiteBrief}
      }
      meta {
        totalItems
      }
    }
  }
`;
export const UPDATE_WEBSITE = gql`
  mutation Mutation($id: ObjectId!, $record: UpdateWebsiteInput!) {
    WebsiteUpdateById(_id: $id, record: $record) {
      ${longWebsite}
    }
  }
`
